import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { AttendanceLogs } from '../enrollment/AttendanceLogs';
import { Attendances } from '../enrollment/Attendances';
import { EnrollmentDetail } from '../enrollment/EnrollmentDetail';
import { LessonProgressDetail } from '../enrollment/LessonProgress';
import { UserDetail } from './UserDetail';
import { UserList } from './UserList';

export const User = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/list`} component={UserList} />
    <Route
      path={`${props.match.path}/:id/enrollment/:enrollmentId/lesson/:serialId`}
      component={LessonProgressDetail}
    />
    <Route
      path={`${props.match.path}/:id/enrollment/:enrollmentId/serial/:serialId/attendances/:lessonId`}
      component={Attendances}
    />
    <Route
      path={`${props.match.path}/:id/enrollment/:enrollmentId/serial/:serialId/attendance/:attendanceId/:lessonId/attendanceLogs`}
      component={AttendanceLogs}
    />
    <Route path={`${props.match.path}/:id/enrollment/:enrollmentId`} component={EnrollmentDetail} />
    <Route path={`${props.match.path}/:id`} component={UserDetail} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/user/User.tsx